import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeValue } from '@angular/platform-browser';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(
    private readonly sanitizer: DomSanitizer,
  ) {
  }

  transform(value: string, type: 'html' | 'js' | 'css' = 'html'): SafeValue {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'js':
        return this.sanitizer.bypassSecurityTrustScript(value);
      case 'css':
        return this.sanitizer.bypassSecurityTrustStyle(value);
      default:
        return '';
    }
  }

}
